import {legacy_createStore, applyMiddleware} from 'redux';
import {persistStore, persistReducer} from 'redux-persist';
import {createMigrate} from 'redux-persist';
import thunk from 'redux-thunk';
import {composeWithDevTools} from 'redux-devtools-extension';
import storage from 'redux-persist/lib/storage';

import rootReducer from './reducers'; // your combined reducers file
import {reducersState} from './reducers'; // for typing RootState if TS

// Bump PERSIST_VERSION whenever you want to force-wipe all persisted data on next load.
const PERSIST_VERSION = 1;
const APP_CACHE_VERSION_KEY = 'app_cache_version';

const migrations: Record<number, (state: any) => any> = {
  [PERSIST_VERSION]: () => undefined, // wipe everything — fresh start
};

// If the stored version is outdated, wipe all browser storage before the store loads.
// Uses a dedicated key instead of parsing redux-persist internals.
const clearOutdatedBrowserStorage = () => {
  try {
    const stored = localStorage.getItem(APP_CACHE_VERSION_KEY);
    console.log('[cache] stored version:', stored, '| expected:', String(PERSIST_VERSION));
    if (stored !== String(PERSIST_VERSION)) {
      console.log('[cache] version mismatch — clearing all browser storage');
      localStorage.clear();
      sessionStorage.clear();
      if ('caches' in window) {
        caches.keys().then(names => names.forEach(name => caches.delete(name)));
      }
      localStorage.setItem(APP_CACHE_VERSION_KEY, String(PERSIST_VERSION));
    }
  } catch {
    localStorage.clear();
    sessionStorage.clear();
  }
};

clearOutdatedBrowserStorage();

const persistConfig = {
  key: 'root',
  storage,
  version: PERSIST_VERSION,
  migrate: createMigrate(migrations, {debug: false}),
  blacklist: ['availability', 'student'],
  throttle: 1000,
};

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Build middleware array
const middleware = [thunk];

// Create the store, wrapped with DevTools
const store = legacy_createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(...middleware)),
);

// Create the persistor to control rehydration
const persistor = persistStore(store);

export type RootState = reducersState;

export {store, persistor};
